import { Component } from '@angular/core';

@Component({
  selector: 'app-utilites',
  template: ``,
  styleUrls: []
})
export class UtilitesComponent {

}
